<a class="text-center block pt-5 pb-8 w-full" href="" routerLink="/dashboard">
  <img alt="MyFirst logo" class="logo" src="/images/logo-sidebar.svg" />
</a>

<div class="flex flex-col justify-between">
  @if (isAuthenticated()) {
    <ul>
      @for (menu of menuMain; track menu.path) {
        <fc-sidebar-item [menuIcon]="menu.menuIcon" [menuTitle]="menu.menuTitle | transloco" [path]="menu.path" />
      }
    </ul>
  }
</div>
